import PageHero from 'components/ui/PageHero';

export default function BenefitsHero() {
  return (
    <PageHero
      eyebrow="THE Mora DIFFERENCE"
      title="The Soul of Gujarat,"
      subtitle="Roasted to Perfection."
      description="Where an ancient art of the land meets the uncompromising standards of the modern gourmet table."
    />
  );
}
